<template>
    <div class="catalog-details-page">
        <component-header
            :title="pageTitle"
            :hasback="true"
            :hasSearch="false"
            :hasCreate="false"
            :hasReload="false"
            backButtonText="Back"
            @back-press="$router.push({path: '/catalog'})"
        />
        <section class="section-b-space">
            <div class="animated fadeIn">
                <b-row v-if="loading">
                    <b-col md="6">
                        <atom-spinner
                            :animation-duration="1000"
                            :size="60"
                            color="#ff1d5e"
                            class="float-right my-4"
                        />
                    </b-col>
                </b-row>
                <ValidationObserver v-else v-slot="{}" ref="observer">
                    <b-row>
                        <b-col sm="12">
                            <b-card
                                class="full-width"
                                border-variant="info"
                                header-bg-variant="primary"
                                header-text-variant="white"
                            >
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group
                                            label="Name *"
                                            label-for="Name"
                                        >
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="name"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="name"
                                                v-model="inputObj.name"
                                                placeholder="Name"
                                            ></b-form-input>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group
                                        label="Display Name *"
                                        label-for="DisplayName"
                                    >
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="display name"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="displayName"
                                                v-model="
                                                    inputObj.catalogDescription
                                                        .displayName
                                                "
                                                placeholder="Enter Catalog Display Name"
                                            ></b-form-input>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group
                                        label="Long Description *"
                                        label-for="LongDescription"
                                    >
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="long description"
                                        >
                                            <b-form-textarea
                                                id="longDescription"
                                                v-model="
                                                    inputObj.catalogDescription
                                                        .longDescription
                                                "
                                                placeholder="Enter something..."
                                                rows="3"
                                                max-rows="6"
                                            ></b-form-textarea>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group
                                        label="Short Description *"
                                        label-for="ShortDescription"
                                    >
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="short description"
                                        >
                                            <b-form-textarea
                                                id="ShortDescription"
                                                v-model="
                                                    inputObj.catalogDescription
                                                        .shortDescription
                                                "
                                                placeholder="Enter something..."
                                                rows="3"
                                                max-rows="6"
                                            ></b-form-textarea>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <v-select
                                        v-model="selectedLanguage"
                                        :items="languages"
                                        item-text="name"
                                        return-object
                                        label="Select Language"
                                        multiple
                                        chips
                                        hint="What are the target language"
                                        persistent-hint
                                    ></v-select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col
                                    md="4"
                                    v-for="(item, index) in selectedLanguage"
                                    :key="index"
                                >
                                    <b-form-group>
                                        <label :for="item.name"
                                            >Catalog Label
                                            {{ item.name }}</label
                                        >
                                        <b-form-input
                                            type="text"
                                            :id="item.name"
                                            v-model="
                                                inputObj.catalogLabel[item.id]
                                            "
                                            :placeholder="`Enter Catalog Label in ${item.name}`"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group label="Select Catalog Type">
                                        <b-form-radio-group
                                            class="text-center"
                                            id="btn-radios-2"
                                            v-model="inputObj.catalogType"
                                            :options="catalogTypes"
                                            buttons
                                            button-variant="outline-primary"
                                            size="sm"
                                            name="radio-btn-outline"
                                            @change="catalogTypeChange"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group
                                        label="Parent"
                                        label-for="status"
                                    >
                                        <ValidationProvider
                                            rules="parentSelected"
                                            v-slot="{ errors }"
                                            name="parent"
                                        >
                                            <vue-select
                                                label="text"
                                                :options="catalogListOption"
                                                v-model="
                                                    parentCatalogItemChange
                                                "
                                                placeholder="Select Catalog"
                                                :disabled="
                                                    selectedCatalogType ===
                                                    'isRoot'
                                                "
                                            ></vue-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <!-- Images Section If create catalog -->

                            <b-row v-if="!$route.params.id">
                                <b-col sm="4" class="mr-sm-5 mr-0">
                                    <b-form-group
                                        label="Thumbnail"
                                        label-for="Thumbnail"
                                    ></b-form-group>
                                    <single-image
                                        height="200px"
                                        width="180px"
                                        @change="changeThumbnail"
                                        id="Thumbnail"
                                        label="Browse for Thumbnail"
                                    ></single-image>
                                </b-col>
                            </b-row>
                            <!-- Images Section If edit catalog -->
                            <b-row v-else>
                                <b-col sm="6">
                                    <b-form-group
                                        label="Icon Image"
                                        label-for="SmallImage"
                                        :label-cols="7"
                                        :horizontal="true"
                                        class="form-group-margin-left"
                                    ></b-form-group>
                                    <single-image
                                        class="mobile-center-icon"
                                        height="180px"
                                        width="200px"
                                        @change="changeThumbnail"
                                        id="icon"
                                        v-if="iconImagedata"
                                        :url="iconImagedata"
                                        label="Browse for Icon"
                                    ></single-image>
                                </b-col>
                            </b-row>
                            <b-row v-if="$route.params.id">
                                <b-col class="text-right">
                                    <div class="form-actions">
                                        <eb-button
                                            classic="mr-1 btn-primary"
                                            @click="updateCatalogDetail"
                                            text="Update Catalog Details"
                                            icon="fa fa-pencil-square-o mr-1"
                                            class="btn-orange catalog-update-btn"
                                            iconSide="left"
                                        ></eb-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
                <!--  Section start  -->
                <b-row v-if="$route.params.id && inputObj.isProductType">
                    <b-col>
                        <b-card
                            header=""
                            border-variant="info"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <div class="custom-library">
                                <div class="custom-button">
                                    <eb-button
                                        class="btn-primary float-right"
                                        @click="onCreateLibrary"
                                        text="Create Library"
                                        icon="fa fa-plus-circle mr-1"
                                        iconSide="left"
                                    ></eb-button>
                                </div>
                                <b-table
                                    :dark="dark"
                                    :hover="hover"
                                    :striped="striped"
                                    :bordered="bordered"
                                    :small="small"
                                    :fixed="fixed"
                                    responsive="sm"
                                    :items="ImageLibraryList"
                                    :fields="imageGalleryColumns"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    show-empty
                                    thead-class="header"
                                    ><template
                                        slot="cell(action)"
                                        slot-scope="data"
                                    >
                                        <div class="action-btn-wrapper">
                                            <button
                                                class="btn btn-primary button-circle"
                                                @click="viewImageLibrary(data)"
                                            >
                                                <i
                                                    class="fa fa-eye text-white"
                                                ></i>
                                            </button>

                                            <button
                                                class="btn btn-primary button-circle btn-orange"
                                                @click="
                                                    updateImageLibrary(data)
                                                "
                                            >
                                                <i
                                                    class="fa fa-pencil text-white"
                                                ></i>
                                            </button>

                                            <button
                                                class="btn btn-danger button-circle"
                                                @click="
                                                    deleteImageLibrary(data)
                                                "
                                            >
                                                <i
                                                    class="fa fa-trash text-white"
                                                ></i>
                                            </button>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
                <!--  Section end  -->

                <b-row v-if="inputObj.parent != 1">
                    <b-col>
                        <b-card
                            header="Parent Catalog"
                            v-show="InheritableAttribuItem.length > 0"
                            border-variant="info"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <b-table
                                :dark="dark"
                                :hover="hover"
                                :striped="striped"
                                :bordered="bordered"
                                :small="small"
                                :fixed="fixed"
                                responsive
                                :items="InheritableAttribuItem"
                                :fields="captions"
                                :current-page="currentPageParent"
                                :per-page="perPage"
                                :filter="filter"
                            >
                                <template slot="cell(sort)" slot-scope="data">
                                    <button
                                        size="sm"
                                        class="btn btn-primary button-circle mr-1 mb-1"
                                        @click="sortUpData(data)"
                                    >
                                        <i
                                            class="fa fa-arrow-up text-white"
                                        ></i>
                                    </button>
                                    <button
                                        size="sm"
                                        class="btn btn-primary button-circle mr-1"
                                        @click="sortDownData(data)"
                                    >
                                        <i
                                            class="fa fa-arrow-down text-white"
                                        ></i>
                                    </button>
                                </template>
                                <template slot="cell(more)" slot-scope="data">
                                    <button
                                        size="sm"
                                        class="btn btn-primary mr-1 button-circle"
                                        @click="openMore(data)"
                                    >
                                        <i class="fa fa-eye text-white"></i>
                                    </button>
                                </template>
                                <template slot="cell(action)" slot-scope="data">
                                    <button
                                        size="sm"
                                        class="btn btn-danger mr-2"
                                        @click="
                                            addAtributeIntoExternalAttribute(
                                                data,
                                            )
                                        "
                                    >
                                        Do you want this attribute
                                    </button>
                                </template>

                                <template
                                    slot="cell(attributeName)"
                                    slot-scope="data"
                                    >{{
                                        data.item.attributeRef.attributeName
                                    }}</template
                                >

                                <template
                                    slot="cell(attributeValueType)"
                                    slot-scope="data"
                                    >{{
                                        data.item.attributeRef
                                            .attributeValueType
                                    }}</template
                                >

                                <template
                                    slot="cell(isComparable)"
                                    slot-scope="data"
                                >
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.isComparable"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                        disabled
                                    />
                                </template>

                                <template
                                    slot="cell(isSearchable)"
                                    slot-scope="data"
                                >
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.isSearchable"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                        disabled
                                    />
                                </template>

                                <template
                                    slot="cell(isInheritable)"
                                    slot-scope="data"
                                >
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.isInheritable"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                        disabled
                                    />
                                </template>

                                <template
                                    slot="cell(isRequired)"
                                    slot-scope="data"
                                >
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.isRequired"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                        disabled
                                    />
                                </template>

                                <template
                                    slot="cell(isVariation)"
                                    slot-scope="data"
                                >
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.isVariation"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                        disabled
                                    />
                                </template>

                                <template
                                    slot="cell(onCreate)"
                                    slot-scope="data"
                                >
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.visibility.onCreate"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                    />
                                </template>

                                <template
                                    slot="cell(onUpdate)"
                                    slot-scope="data"
                                >
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.onUpdate"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                    />
                                </template>

                                <template slot="cell(onShow)" slot-scope="data">
                                    <c-switch
                                        class="mx-1"
                                        color="primary"
                                        v-model="data.item.onShow"
                                        label
                                        variant="pill"
                                        data-on="yes"
                                        data-off="no"
                                    />
                                </template>
                            </b-table>
                            <nav>
                                <b-pagination
                                    :total-rows="InheritableAttribuItem.length"
                                    :per-page="perPage"
                                    v-model="currentPageParent"
                                    prev-text="Prev"
                                    next-text="Next"
                                    hide-goto-end-buttons
                                />
                            </nav>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-card
                            header="External Attributes"
                            border-variant="info"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <b-row class="align-items-end">
                                <!-- Attribute Select -->
                                <b-col cols="12" md="6" class="mb-2 mb-md-4">
                                    <b-form-group
                                        label="Attribute"
                                        label-for="Name"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="mb-0"
                                    >
                                        <vue-select
                                            label="text"
                                            :options="attributeItem"
                                            v-model="attribute"
                                            placeholder="Please Select Attribute"
                                        />
                                    </b-form-group>
                                </b-col>

                                <!-- Add Attribute Button -->
                                <b-col
                                    cols="12"
                                    md="3"
                                    class="mb-2 mb-md-4 d-flex justify-content-start justify-content-md-start"
                                >
                                    <eb-button
                                        class="btn-primary w-100 w-md-auto btn-equal-height"
                                        @click="addAttributeIntoTable"
                                        text="Add Attribute"
                                        icon="fa fa-plus-circle mr-2"
                                        iconSide="left"
                                    />
                                </b-col>

                                <!-- Search Input -->
                                <b-col cols="12" md="3">
                                    <b-form-group class="mb-4">
                                        <b-input-group>
                                            <b-form-input
                                                v-model="filter"
                                                placeholder="Type to Search"
                                            />
                                            <b-input-group-append>
                                                <eb-button
                                                    class="btn-primary"
                                                    text="Clear"
                                                    :disabled="!filter"
                                                    @click="filter = ''"
                                                />
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div v-show="externalAttributesItem.length > 0">
                                <b-table
                                    :dark="dark"
                                    :hover="hover"
                                    thead-class="header"
                                    :striped="striped"
                                    :bordered="bordered"
                                    :small="small"
                                    :fixed="fixed"
                                    responsive
                                    :items="externalAttributesItem"
                                    :fields="captions"
                                    :current-page="currentPageExternal"
                                    :per-page="perPage"
                                    :filter="filter"
                                >
                                    <template
                                        slot="cell(action)"
                                        slot-scope="data"
                                    >
                                        <button
                                            v-if="
                                                !data.item
                                                    .isInheritableNotRemovable &&
                                                data.item.isVariation
                                            "
                                            size="sm"
                                            class="btn btn-primary mr-2 button-circle btn-orange"
                                            @click="updateVariance(data)"
                                        >
                                            <i
                                                class="fa fa-pencil text-white"
                                            ></i>
                                        </button>
                                        <button
                                            v-if="
                                                !data.item
                                                    .isInheritableNotRemovable
                                            "
                                            size="sm"
                                            class="btn btn-danger mr-2 button-circle"
                                            @click="deleteAttribute(data)"
                                        >
                                            <i
                                                class="fa fa-trash bin text-white"
                                            ></i>
                                        </button>
                                    </template>

                                    <template
                                        slot="cell(attributeName)"
                                        slot-scope="data"
                                    >
                                        <span v-if="data.item.attributeRef">{{
                                            data.item.attributeRef.attributeName
                                        }}</span>
                                        <span v-else>{{
                                            data.item.attributeName
                                        }}</span>
                                    </template>

                                    <template
                                        slot="cell(attributeValueType)"
                                        slot-scope="data"
                                    >
                                        <span v-if="data.item.attributeRef">{{
                                            data.item.attributeRef
                                                .attributeValueType
                                        }}</span>
                                        <span v-else>{{
                                            data.item.attributeValueType
                                        }}</span>
                                    </template>

                                    <template
                                        slot="cell(isSearchable)"
                                        slot-scope="data"
                                    >
                                        <c-switch
                                            class="mx-1"
                                            color="primary"
                                            v-model="data.item.isSearchable"
                                            label
                                            variant="pill"
                                            data-on="yes"
                                            data-off="no"
                                            :disabled="
                                                data.item
                                                    .isInheritableNotRemovable
                                            "
                                        />
                                    </template>

                                    <template
                                        slot="cell(isInheritable)"
                                        slot-scope="data"
                                    >
                                        <c-switch
                                            class="mx-1"
                                            color="primary"
                                            v-model="data.item.isInheritable"
                                            label
                                            variant="pill"
                                            data-on="yes"
                                            data-off="no"
                                            :disabled="
                                                data.item
                                                    .isInheritableNotRemovable
                                            "
                                        />
                                    </template>

                                    <template
                                        slot="cell(isRequired)"
                                        slot-scope="data"
                                    >
                                        <c-switch
                                            class="mx-1"
                                            color="primary"
                                            v-model="data.item.isRequired"
                                            label
                                            variant="pill"
                                            data-on="yes"
                                            data-off="no"
                                            :disabled="
                                                data.item
                                                    .isInheritableNotRemovable
                                            "
                                        />
                                    </template>

                                    <template
                                        slot="cell(sort)"
                                        slot-scope="data"
                                    >
                                        <button
                                            size="sm"
                                            class="btn btn-primary mr-1 mb-1 button-circle"
                                            @click="sortUp(data)"
                                        >
                                            <i
                                                class="fa fa-arrow-up text-white"
                                            ></i>
                                        </button>
                                        <button
                                            size="sm"
                                            class="btn btn-primary mr-1 button-circle"
                                            @click="sortDown(data)"
                                        >
                                            <i
                                                class="fa fa-arrow-down text-white"
                                            ></i>
                                        </button>
                                    </template>

                                    <template
                                        slot="cell(more)"
                                        slot-scope="data"
                                    >
                                        <button
                                            size="sm"
                                            class="btn btn-primary mr-1 button-circle"
                                            @click="openMore(data)"
                                        >
                                            <i class="fa fa-eye text-white"></i>
                                        </button>
                                    </template>

                                    <template
                                        slot="cell(isVariation)"
                                        slot-scope="data"
                                    >
                                        <c-switch
                                            class="mx-1"
                                            color="primary"
                                            v-model="data.item.isVariation"
                                            label
                                            variant="pill"
                                            data-on="yes"
                                            data-off="no"
                                            @change.native="
                                                onSwitchUpdate(data.item)
                                            "
                                            :disabled="
                                                data.item
                                                    .isInheritableNotRemovable
                                            "
                                        />
                                    </template>

                                    <template
                                        slot="cell(default)"
                                        slot-scope="data"
                                    >
                                        <b-form-select
                                            v-if="
                                                data.item.attributeName ==
                                                'Tax Code'
                                            "
                                            v-model="data.item.defaultValue"
                                            :options="taxcodeList"
                                            size="md"
                                            class="default-tax-class"
                                        ></b-form-select>
                                        <b-form-input
                                            v-if="
                                                data.item.attributeName !=
                                                'Tax Code'
                                            "
                                            v-model="data.item.defaultValue"
                                        ></b-form-input>
                                    </template>

                                    <template
                                        slot="cell(onCreate)"
                                        slot-scope="data"
                                    >
                                        <c-switch
                                            class="mx-1"
                                            color="primary"
                                            v-model="data.item.onCreate"
                                            label
                                            variant="pill"
                                            data-on="yes"
                                            data-off="no"
                                            :disabled="
                                                data.item
                                                    .isInheritableNotRemovable
                                            "
                                        />
                                    </template>
                                    <template
                                        slot="cell(onUpdate)"
                                        slot-scope="data"
                                    >
                                        <c-switch
                                            class="mx-1"
                                            color="primary"
                                            v-model="data.item.onUpdate"
                                            label
                                            variant="pill"
                                            data-on="yes"
                                            data-off="no"
                                            :disabled="
                                                data.item
                                                    .isInheritableNotRemovable
                                            "
                                        />
                                    </template>

                                    <template
                                        slot="cell(onShow)"
                                        slot-scope="data"
                                    >
                                        <c-switch
                                            class="mx-1"
                                            color="primary"
                                            v-model="data.item.onShow"
                                            label
                                            variant="pill"
                                            data-on="yes"
                                            data-off="no"
                                            :disabled="
                                                data.item
                                                    .isInheritableNotRemovable
                                            "
                                        />
                                    </template>
                                </b-table>
                                <nav>
                                    <b-pagination
                                        align="right"
                                        :total-rows="externalAttributesItem.length"
                                        :per-page="perPage"
                                        v-model="currentPageExternal"
                                        prev-text="Prev"
                                        next-text="Next"
                                        hide-goto-end-buttons
                                        :currentPage="tableData.currentPage"
                                    />
                                </nav>
                            </div>
                            <b-row v-if="!externalAttributesItem.length > 0">
                                <b-col md="12 mt-2">
                                    <b-alert
                                        v-model="showDismissibleAlert"
                                        variant="info"
                                        dismissible
                                        >Yet Not Added Any Attribute</b-alert
                                    >
                                </b-col>
                            </b-row>
                            <!-- Order Input -->
                            <b-row
                                v-if="inputObj.catalogType == 'isProductType'"
                            >
                                <b-col>
                                    <b-card
                                        header="Order Input"
                                        border-variant="info"
                                        header-bg-variant="primary"
                                        header-text-variant="white"
                                    >
                                        <b-row v-if="!$route.params.id">
                                            <b-col sm="6">
                                                <b-form-group
                                                    label="Attribute"
                                                    label-for="Name"
                                                    :label-cols="3"
                                                    :horizontal="true"
                                                >
                                                    <vue-select
                                                        label="text"
                                                        :options="attributeItem"
                                                        v-model="attribute"
                                                    />
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="3" class="mt-0">
                                                <eb-button
                                                    classic="mr-1 btn-primary"
                                                    @click="
                                                        addAttributeIntoTableOrder
                                                    "
                                                    text="Add Attribute"
                                                    icon="fa fa-plus-circle mr-1"
                                                    iconSide="left"
                                                />
                                            </b-col>
                                            <b-col md="3" class="mt-0">
                                                <b-form-group
                                                    label-cols-sm="3"
                                                    class="mb-0"
                                                >
                                                    <b-input-group>
                                                        <b-form-input
                                                            v-model="filter1"
                                                            placeholder="Type to Search"
                                                        />
                                                        <b-input-group-append>
                                                            <eb-button
                                                                classic="mr-1 btn-primary"
                                                                text="Clear"
                                                                :disabled="
                                                                    !filter1
                                                                "
                                                                @click="
                                                                    filter1 = ''
                                                                "
                                                            />
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>

                                        <b-row v-else>
                                            <b-col sm="6">
                                                <b-form-group
                                                    label="Attribute"
                                                    label-for="Name"
                                                    :label-cols="3"
                                                    :horizontal="true"
                                                >
                                                    <vue-select
                                                        label="text"
                                                        :options="attributeItem"
                                                        v-model="attribute"
                                                    />
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="3" class="mt-2">
                                                <eb-button
                                                    classic="mr-1 btn-primary"
                                                    @click="
                                                        addAttributeIntoTableOrder
                                                    "
                                                    text="Add Attribute"
                                                    icon="fa fa-plus-circle mr-1"
                                                    iconSide="left"
                                                />
                                            </b-col>
                                            <b-col md="3" class="mt-2">
                                                <b-form-group
                                                    label-cols-sm="3"
                                                    class="mb-0"
                                                >
                                                    <b-input-group>
                                                        <b-form-input
                                                            v-model="filter1"
                                                            placeholder="Type to Search"
                                                        />
                                                        <b-input-group-append>
                                                            <eb-button
                                                                classic="mr-1 btn-primary"
                                                                text="Clear"
                                                                :disabled="
                                                                    !filter1
                                                                "
                                                                @click="
                                                                    filter1 = ''
                                                                "
                                                            />
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>

                                        <div
                                            v-show="
                                                orderAttributesItem.length > 0
                                            "
                                        >
                                            <b-table
                                                :dark="dark"
                                                :hover="hover"
                                                thead-class="header"
                                                :striped="striped"
                                                :bordered="bordered"
                                                :small="small"
                                                :fixed="fixed"
                                                responsive="sm"
                                                :items="orderAttributesItem"
                                                :fields="
                                                    itemFieldsForOrderInput
                                                "
                                                :current-page="currentPage1"
                                                :per-page="perPage1"
                                                :filter="filter1"
                                            >
                                                <template
                                                    slot="isRequired"
                                                    slot-scope="data"
                                                >
                                                    <c-switch
                                                        class="mx-1"
                                                        color="primary"
                                                        v-model="
                                                            data.item.isRequired
                                                        "
                                                        label
                                                        variant="pill"
                                                        data-on="yes"
                                                        data-off="no"
                                                        :disabled="
                                                            data.item
                                                                .isInheritableNotRemovable
                                                        "
                                                    />
                                                </template>

                                                <template
                                                    slot="applicableTo"
                                                    slot-scope="data"
                                                >
                                                    <eb-select
                                                        type="text"
                                                        v-model="
                                                            data.item
                                                                .applicableTo
                                                        "
                                                        :options="
                                                            applicableToOptions
                                                        "
                                                        placeholder="Select ApplicableTo"
                                                    ></eb-select>
                                                </template>

                                                <template
                                                    slot="cell(action)"
                                                    slot-scope="data"
                                                >
                                                    <button
                                                        size="sm"
                                                        class="btn btn-danger mr-2"
                                                        @click="
                                                            deleteAttributeOrder(
                                                                data,
                                                            )
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-trash bin text-white"
                                                        ></i>
                                                    </button>
                                                </template>
                                            </b-table>
                                            <nav>
                                                <b-pagination
                                                    :total-rows="
                                                        orderAttributesItem.length
                                                    "
                                                    :per-page="perPage1"
                                                    v-model="currentPage1"
                                                    prev-text="Prev"
                                                    next-text="Next"
                                                    hide-goto-end-buttons
                                                />
                                            </nav>
                                        </div>
                                        <b-row
                                            v-if="
                                                !orderAttributesItem.length > 0
                                            "
                                        >
                                            <b-col md="12 mt-2">
                                                <b-alert
                                                    v-model="
                                                        showDismissibleAlert
                                                    "
                                                    variant="info"
                                                    dismissible
                                                    >Yet Not Added Any
                                                    Attribute</b-alert
                                                >
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col
                                    cols="12"
                                    class="d-flex justify-content-center"
                                >
                                    <div
                                        class="form-actions d-flex justify-content-center"
                                        v-if="!$route.params.id"
                                    >
                                        <router-link
                                            to="/catalog"
                                            class="mr-2 text-right"
                                        >
                                            <eb-button
                                                class="btn-danger action-btn"
                                                text="Cancel"
                                                icon="fa fa-arrow-left mr-2"
                                                iconSide="left"
                                            />
                                        </router-link>

                                        <router-link to="/catalog">
                                            <eb-button
                                                class="btn-primary save-btn"
                                                @click="createCatalog"
                                                :disabled="invalid"
                                                text="Save"
                                                icon="fa fa-plus-circle mr-2"
                                                iconSide="left"
                                            />
                                        </router-link>
                                    </div>

                                    <div
                                        class="form-actions d-flex justify-content-center"
                                        v-else-if="
                                            externalAttributesItem.length > 0
                                        "
                                    >
                                        <router-link to="/catalog" class="mr-2">
                                            <eb-button
                                                class="btn-danger action-btn"
                                                text="Cancel"
                                                icon="fa fa-arrow-left mr-2"
                                                iconSide="left"
                                            />
                                        </router-link>
                                        <div class="upd-btn">
                                            <eb-button
                                                class="btn-primary action-btn btn-orange"
                                                @click="updateCatalog"
                                                text="Update"
                                                icon="fa fa-pencil-square-o mr-2"
                                                iconSide="left"
                                            />
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>

                <!-- Modal for default value -->
                <b-modal
                    v-model="isMoreModalOpen"
                    :title="currentAttributeName ? currentAttributeName : ''"
                    :centered="true"
                    size="lg"
                    scrollable
                    hide-footer
                    no-close-on-backdrop
                    no-close-on-esc
                >
                    <b-row class="mb-2 mobile-switch-align">
                        <b-col cols="2">
                            <div class="d-flex flex-column">
                                <label for="a">Default Value :</label>
                                <label for="b" class="mt-4">useInName :</label>
                                <label for="c" class="mt-2">Comparable :</label>
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <div class="d-flex flex-column">
                                <b-form-input
                                    class="mx-1"
                                    label="Default Value"
                                    placeholder="Default Value"
                                    v-model="defaultAttrValue"
                                />
                                <c-switch
                                    class="mt-3"
                                    color="primary"
                                    variant="pill"
                                    data-on="yes"
                                    data-off="no"
                                    v-model="selectedAttribute.useInName"
                                />
                                <c-switch
                                    class="mt-3"
                                    color="primary"
                                    variant="pill"
                                    data-on="yes"
                                    data-off="no"
                                    v-model="selectedAttribute.isComparable"
                                />
                            </div>
                        </b-col>
                    </b-row>
                    <div class="modal-actions-center">
                        <b-row>
                            <b-col cols="6">
                                <eb-button
                                    class="mr-1 btn-primary-save"
                                    @click="saveDefaultValue"
                                    text="Save"
                                    icon="fa fa-plus-circle mr-1"
                                    iconSide="left"
                                />
                            </b-col>
                        </b-row>
                    </div>
                </b-modal>

                <!-- Modal for catalog -->
                <b-modal
                    v-model="openModal"
                    :title="currentVarianceData ? currentAttributeName : ''"
                    size="lg"
                    scrollable
                    :centered="true"
                >
                    <b-row class="mb-2">
                        <b-col cols="6">
                            <b-form-input label="text" v-model="variantText" />
                        </b-col>
                        <b-col cols="6">
                            <eb-button
                                classic="mr-1 btn-primary"
                                @click="addvariant"
                                :disabled="variantText === ''"
                                text="Add variant"
                                icon="fa fa-plus-circle mr-1"
                                iconSide="left"
                            />
                        </b-col>
                    </b-row>
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <b-input-group>
                            <b-row>
                                <b-col cols="4">
                                    <b-form-input
                                        v-model="filter"
                                        placeholder="Type to Search"
                                    />
                                </b-col>
                                <b-col cols="8">
                                    <b-input-group-append>
                                        <eb-button
                                            classic="mr-1 btn-primary"
                                            text="Clear"
                                            :disabled="!filter"
                                            @click="filter = ''"
                                        />
                                    </b-input-group-append>
                                </b-col>
                            </b-row>
                        </b-input-group>
                    </b-form-group>

                    <b-row class="mt-3">
                        <b-table
                            :dark="dark"
                            thead-class="header"
                            bordered
                            small
                            fixed
                            :items="currentVarianceData.data"
                            :fields="variant"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            show-empty
                        >
                            <template slot="cell(action)" slot-scope="data">
                                <button
                                    size="sm"
                                    class="btn btn-danger mr-2"
                                    @click="deleteVariant(data)"
                                >
                                    <i class="fa fa-trash bin text-white"></i>
                                </button>
                            </template>
                        </b-table>
                        <b-pagination
                            v-if="currentVarianceData.data.length > 0"
                            :total-rows="currentVarianceData.data.length"
                            :per-page="10"
                            :current-page="currentPage"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        />
                    </b-row>
                </b-modal>

                <!-- Modal for  -->

                <b-modal
                    v-model="isGalleryModal"
                    :title="currentVarianceData ? currentAttributeName : ''"
                    @show="resetImage"
                    size="lg"
                    scrollable
                    hide-footer
                    centered
                    no-close-on-backdrop
                    no-close-on-esc
                >
                    <b-form-group label-cols-sm="12" class="mb-0">
                        <b-input-group>
                            <b-row>
                                <b-col cols="6">
                                    <b-form-input
                                        v-model="imageGalleryObject.title"
                                        placeholder="Title"
                                        class="gallery-input-title"
                                    />
                                </b-col>
                                <b-col cols="6">
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="imageGalleryObject.description"
                                        placeholder="Description"
                                        rows="2"
                                        max-rows="6"
                                        class="gallery-textarea"
                                    ></b-form-textarea>
                                </b-col>
                            </b-row>
                        </b-input-group>
                    </b-form-group>

                    <b-row class="mt-3">
                        <b-col sm="4">
                            <b-form-group
                                label="Icon"
                                label-for="Icon1"
                                id="Icon1"
                                :label-cols="7"
                                class="form-group-margin-left-large"
                            ></b-form-group>
                            <single-image
                                height="200px"
                                width="180px"
                                class="image-margin-left"
                                @change="changeIcon"
                                :id="'icon1'"
                                ref="iconImage"
                                :url="imageGalleryObject.images.icon"
                                label="Browse for Icon"
                            ></single-image>
                        </b-col>

                        <b-col sm="4">
                            <b-form-group
                                label="Small Image"
                                label-for="SmallImage"
                                :label-cols="7"
                                :horizontal="true"
                                class="form-group-margin-left-medium"
                            ></b-form-group>
                            <single-image
                                height="200px"
                                width="180px"
                                class="image-margin-left-small"
                                @change="changeSmallImage"
                                :id="'smallImage'"
                                ref="smallImage"
                                :url="imageGalleryObject.images.smallImage"
                                label="Browse Small Image"
                            ></single-image>
                        </b-col>

                        <b-col sm="4">
                            <b-form-group
                                label="Big Image"
                                label-for="BigImage"
                                :label-cols="7"
                                :horizontal="true"
                                class="form-group-margin-left-medium-small"
                            ></b-form-group>
                            <single-image
                                height="200px"
                                width="180px"
                                @change="changeBigImage"
                                :id="'bigImage'"
                                :url="imageGalleryObject.images.bigImage"
                                ref="bigImage"
                                label="Browse for Big Image"
                            ></single-image>
                        </b-col>
                    </b-row>

                    <!-- ✅ Footer Buttons (side by side) -->
                    <b-row class="mt-4 justify-content-center">
                        <eb-button
                            class="btn-cancel-modal"
                            classic="btn btn-danger"
                            text="Cancel"
                            @click="isGalleryModal = false"
                        />
                        <eb-button
                            class="btn-save-modal"
                            classic="btn btn-primary"
                            text="Save"
                            @click="saveImageGallery"
                        />
                    </b-row>
                </b-modal>
            </ValidationObserver>
        </div>
        </section>
    </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import vSelect from "vue-select";
import cTable from "@/views/base/Table.vue";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage.vue";
import SingleImage from "@/components/Common/Image.vue";
import ebButton from "@/components/FormElements/Button";
import { AtomSpinner } from "epic-spinners";
import { BUCKET_BASEURL, GATEWAY_BASEURL } from "@/services/index";
import { mapActions, mapGetters } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import componentHeader from "@/components/componentNewHeader";

export default {
    name: "CatalogDetails",
    dark: {
        type: Boolean,
        default: false,
    },
    components: {
        componentHeader,
        AtomSpinner,
        ValidationObserver,
        cSwitch,
        cTable,
        ebSelect,
        "vue-select": vSelect,
        VueUploadMultipleImage,
        SingleImage,
        ebButton,
        ValidationProvider,
    },
    props: {
        edit: Boolean,
    },
    data() {
        return {
            // UI State / Loading
            loading: false,
            showDismissibleAlert: true,
            isDisable: true,
            changeCount: 0,

            // Table UI Configuration
            dark: false,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            applicableToOptions: ["ORDER", "QUOTE", "BOTH"],
            langObj: {
                en: "English",
                be: "Bengali",
                te: "Telugu",
                hi: "Hindi",
            },
            selectedLanguage: [],
            languages: [
                { id: "en", name: "English" },
                { id: "bn", name: "Bengali" },
                { id: "te", name: "Telugu" },
                { id: "hi", name: "Hindi" },
            ],
            variantText: "",
            currentAttributeName: "",
            defaultAttrValue: "",
            selectedAttribute: {},
            openModal: false,
            isGalleryModal: false,
            isMoreModalOpen: false,
            imageGalleryUI: "CREATE",
            iconImagedata: null,
            smallImagedata: null,
            landingImagedata: null,

            selectedCatalogType: "isRoot",
            inputObj: {
                name: "",
                catalogLabel: {},
                catalogType: "isRoot",
                parent: "",
                catalogDescription: {
                    displayName: "",
                    longDescription: "",
                    shortDescription: "",
                },
                externalAttributes: [],
            },

            // Images
            images: {
                // landing: [],
                thumbnail: "",
                // small: []
            },
            imageGalleryObject: {
                title: "",
                description: "",
                catalogId: this.$route.params.id,
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                    alternateImages: [],
                },
            },
            // Attributes
            attribute: [],
            attributeItem: [],
            tempAttribute: [],
            attributeValueType: null,
            externalAttributesItem: [],
            orderAttributesItem: [],
            InheritableAttribuItem: [],
            variations: [],
            currentVarianceData: {
                data: [],
            },
            isParent: "true",

            // Catalog Data
            catalogList: [],
            catalogListOption: [],
            catalogResultItem: [],

            // Table Configuration
            catalogFields: [
                {
                    key: "sort",
                    label: "Sort",
                },
                {
                    key: "attributeName",
                    label: "Field Name",
                    sortable: true,
                },
                {
                    key: "attributeValueType",
                    label: "Type",
                    sortable: true,
                },
                {
                    key: "isSearchable",
                    label: "Searchable",
                },
                {
                    key: "isInheritable",
                    label: "Inheritable",
                },
                {
                    key: "isRequired",
                    label: "Required",
                },
                {
                    key: "isVariation",
                    label: "Variance",
                },
                {
                    key: "onCreate",
                    label: "Visible on Create",
                },
                {
                    key: "onUpdate",
                    label: "Visible on Update",
                },
                {
                    key: "onShow",
                    label: "Visible on Show",
                },
                {
                    key: "more",
                    label: "More",
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            itemFieldsForOrderInput: [
                {
                    key: "attributeName",
                    label: "Field Name",
                    sortable: true,
                },
                {
                    key: "attributeValueType",
                    label: "Type",
                    sortable: true,
                },
                {
                    key: "isRequired",
                    label: "Required",
                },
                {
                    key: "applicableTo",
                    label: "applicableTo",
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            variantfield: [
                {
                    key: "variant",
                    label: "Variance value ",
                },
                {
                    key: "action",
                    label: "Action ",
                },
            ],
            imageGalleryColumns: [
                {
                    key: "title",
                    label: "Title",
                },
                {
                    key: "description",
                    label: "Description ",
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            tableData: [],
            caption: "Table",

            // Pagination
            filter: "",
            filter1: "",
            perPage: 10,
            perPage1: 5,
            pageOptions: [10, 15, 20, 25, 30],
            currentPage: 1,
            currentPageParent: 1,
            currentPageExternal: 1,
            currentPage1: 1,

            // Constants / Options
            applicableToOptions: ["ORDER", "QUOTE", "BOTH"],
            langObj: {
                en: "English",
                be: "Bengali",
                te: "Telugu",
                hi: "Hindi",
            },
            languages: [
                { id: "en", name: "English" },
                { id: "bn", name: "Bengali" },
                { id: "te", name: "Telugu" },
                { id: "hi", name: "Hindi" },
            ],
        };
    },

    methods: {
        handleBack() {
            this.$router.push("/catalog");
        },
        ...mapActions({
            getImageLibraryList: "catalog/listImageLibrary",
            createLibrary: "catalog/createImageLibrary",
            updateLibrary: "catalog/updateImageLibrary",
            deleteLibrary: "catalog/deleteImageLibrary",
            getLibraryDetail: "catalog/getImageLibraryById",
        }),
        // Sorting Methods
        sortUpData(data) {
            const currentIndex =
                data.index + this.perPage * (this.currentPageParent - 1);
            if (currentIndex !== 0) {
                this.InheritableAttribuItem = this.arraymove(
                    this.InheritableAttribuItem,
                    currentIndex,
                    currentIndex - 1,
                );
            }
        },
        sortDownData(data) {
            const currentIndex =
                data.index + this.perPage * (this.currentPageParent - 1);
            if (currentIndex !== this.InheritableAttribuItem.length - 1) {
                this.InheritableAttribuItem = this.arraymove(
                    this.InheritableAttribuItem,
                    currentIndex,
                    currentIndex + 1,
                );
            }
        },
        sortUp(data) {
            const currentIndex =
                data.index + this.perPage * (this.currentPageExternal - 1);
            if (currentIndex !== 0) {
                this.externalAttributesItem = this.arraymove(
                    this.externalAttributesItem,
                    currentIndex,
                    currentIndex - 1,
                );
            }
        },
        sortDown(data) {
            const currentIndex =
                data.index + this.perPage * (this.currentPageExternal - 1);
            if (currentIndex !== this.externalAttributesItem.length - 1) {
                this.externalAttributesItem = this.arraymove(
                    this.externalAttributesItem,
                    currentIndex,
                    currentIndex + 1,
                );
            }
        },

        arraymove(arr, fromIndex, toIndex) {
            let copyarr = [].concat(arr);
            copyarr[fromIndex] = arr[toIndex];
            copyarr[toIndex] = arr[fromIndex];
            this.externalAttributesItem = [];
            return copyarr;
        },
        saveImageGallery() {
            if (this.imageGalleryUI === "CREATE") {
                this.createLibrary(this.imageGalleryObject).then((response) => {
                    this.getImageLibraryList(this.catalogId);
                    this.isGalleryModal = false;
                    this.imageGalleryObject = {
                        title: "",
                        description: "",
                        catalogId: this.$route.params.id,
                        images: {
                            icon: "",
                            smallImage: "",
                            bigImage: "",
                            alternateImages: [],
                        },
                    };
                });
            } else if (this.imageGalleryUI === "UPDATE") {
                console.log(this.imageGalleryObject);
                let dataobj = {
                    id: this.imageGalleryObject._id,
                    data: {
                        title: this.imageGalleryObject.title,
                        description: this.imageGalleryObject.description,
                        catalogId: this.catalogId,
                        images: this.imageGalleryObject.images,
                    },
                };
                this.updateLibrary(dataobj).then((response) => {
                    this.getImageLibraryList(this.catalogId);
                    this.isGalleryModal = false;
                    this.imageGalleryObject = {
                        title: "",
                        description: "",
                        catalogId: this.$route.params.id,
                        images: {
                            icon: "",
                            smallImage: "",
                            bigImage: "",
                            alternateImages: [],
                        },
                    };
                });
            } else {
                this.isGalleryModal = false;
            }
        },
        viewImageLibrary(data) {
            this.imageGalleryUI = "VIEW";
            this.imageGalleryObject = data.item;
            this.isGalleryModal = true;
        },
        updateImageLibrary(data) {
            this.imageGalleryUI = "UPDATE";
            this.imageGalleryObject = data.item;
            this.isGalleryModal = true;
        },
        deleteImageLibrary(data) {
            this.deleteLibrary(data.item._id).then((response) => {
                this.getImageLibraryList(this.catalogId);
            });
        },
        resetImage() {
            this.$refs.iconImage.reset();
            this.$refs.smallImage.reset();
            this.$refs.bigImage.reset();
        },
        onCreateLibrary() {
            this.isGalleryModal = true;
            this.imageGalleryUI = "CREATE";
            this.imageGalleryObject = {
                title: "",
                description: "",
                catalogId: this.$route.params.id,
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                    alternateImages: [],
                },
            };
        },
        fetchImages() {
            this.iconImagedata = this.inputObj.images.thumbnail;
        },
        getImageKeyfromURL(imageURL) {
            return imageURL.replace(BUCKET_BASEURL, "");
        },
        // resize image storage service
        getImageUrl(imageURL) {
            const imageKey = this.getImageKeyfromURL(imageURL);
            return `${GATEWAY_BASEURL}/resize/index.php?width=300&height=250&quality=100&name=${imageKey}`;
        },
        changeIcon(e) {
            this.uploadImage("icon", e);
        },
        changeSmallImage(e) {
            this.uploadImage("smallImage", e);
        },
        changeBigImage(e) {
            this.uploadImage("bigImage", e);
        },
        // upload images to the S3 bucket
        async uploadImage(type, image) {
            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: "catalog",
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    if (res) {
                        this.clearCustomToast();
                        if (type === "thumbnail") {
                            this.iconImagedata = res.data.fileUrl;
                            this.images.thumbnail = res.data.fileUrl;
                        } else if (type === "icon") {
                            this.imageGalleryObject.images.icon =
                                res.data.fileUrl;
                        } else if (type === "smallImage") {
                            this.imageGalleryObject.images.smallImage =
                                res.data.fileUrl;
                        } else if (type === "bigImage") {
                            this.imageGalleryObject.images.bigImage =
                                res.data.fileUrl;
                        }
                    }
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        openMore(data) {
            this.defaultAttrValue = "";
            this.selectedAttribute = data.item;
            console.log(this.selectedAttribute);
            this.currentAttributeName = data.item.attributeName;
            this.defaultAttrValue = data.item.defaultValue;
            this.isMoreModalOpen = true;
        },
        saveDefaultValue() {
            this.isMoreModalOpen = false;
            this.externalAttributesItem.map((obj) => {
                if (obj._id === this.selectedAttribute._id) {
                    obj["defaultValue"] = this.defaultAttrValue;
                    this.defaultAttrValue = "";
                    obj["useInName"] = this.selectedAttribute.useInName;
                    obj["isComparable"] = this.selectedAttribute.isComparable;
                }
            });
        },
        addvariant() {
            this.variations.map((obj) => {
                if (obj.attrRef === this.currentVarianceData.attrRef) {
                    obj.data.push({ variant: this.variantText });
                }
            });
            this.currentVarianceData.data.push({ variant: this.variantText });
            let newArray = [];
            this.currentVarianceData.data.filter(function (item) {
                var i = newArray.findIndex((x) => x.variant == item.variant);
                if (i <= -1) {
                    newArray.push({ variant: item.variant });
                }
                return null;
            });
            this.currentVarianceData.data = newArray;
            this.$forceUpdate();
            this.variantText = "";
        },
        updateVariance(data) {
            this.currentPage = 1;
            const variation = this.variations.find(
                (obj) => obj.attrRef === data.item._id,
            );
            if (variation) {
                this.currentVarianceData = { ...variation };
                this.currentAttributeName = data.item.attributeName || "";
                this.openModal = true;
            }
        },
        deleteVariant(data) {
            if (data) {
                this.variations.map((obj) => {
                    if (obj.attrRef === this.currentVarianceData.attrRef) {
                        obj.data = obj.data.filter(
                            (subObj) => subObj.variant !== data.item.variant,
                        );
                    }
                });
                this.currentVarianceData.data =
                    this.currentVarianceData.data.filter(
                        (subObj) => subObj.variant !== data.item.variant,
                    );
            }
        },
        async updateCatalogDetail() {
            // filter Label object with selected Lang.
            if (this.selectedLanguage.length > 0) {
                let keys = Object.keys(this.inputObj.catalogLabel);
                keys.map((key) => {
                    const ifKeyExist = this.selectedLanguage.some(
                        (obj) => obj.id === key,
                    );
                    if (!ifKeyExist) {
                        delete this.inputObj.catalogLabel[key];
                    }
                });
            }

            const payload = {
                _id: this.$route.params.id,
                data: {
                    name: this.inputObj.name,
                    catalogLabel: this.inputObj.catalogLabel,
                    catalogDescription: this.inputObj.catalogDescription,
                    images:
                        this.images.thumbnail !== ""
                            ? this.images
                            : this.inputObj.images,
                    isRoot: this.inputObj.isRoot,
                    isDomain: this.inputObj.isDomain,
                    isMarket: this.inputObj.isMarket,
                    isCategory: this.inputObj.isCategory,
                    isProductType: this.inputObj.isProductType,
                    parent:
                        typeof this.inputObj.parent === "object"
                            ? this.inputObj.parent.value
                            : this.inputObj.parent,
                },
            };

            if (this.images.thumbnail) {
                const imageKey = this.getImageKeyfromURL(
                    this.inputObj.images.thumbnail,
                );
                if (imageKey) {
                    await this.$store.dispatch(
                        "inventory/deleteFileFromStorage",
                        {
                            key: imageKey,
                        },
                    );
                }
            }
            this.$store
                .dispatch("catalog/updateCatalog", payload)
                .then((res) => {
                    if (res) {
                        this.$toasted.success(
                            "Catalog details updated successfully!",
                        );
                    }
                });
        },
        async updateCatalog() {
            let updatedAttributes = [];
            this.externalAttributesItem.map((Obj) => {
                let Object = {
                    attributeRef: Obj._id,
                    isComparable: Obj.isComparable,
                    isSearchable: Obj.isSearchable,
                    isInheritable: Obj.isInheritable,
                    isRequired: Obj.isRequired,
                    isVariation: Obj.isVariation,
                    defaultValue: Obj.defaultValue,
                    useInName: Obj.useInName,
                    visibility: {
                        onCreate: Obj.onCreate,
                        onUpdate: Obj.onUpdate,
                        onShow: Obj.onShow,
                    },
                };
                updatedAttributes.push(Object);
            });
            if (this.variations && this.variations.length > 0) {
                this.variations.map((obj) => {
                    if (obj) {
                        let data = [];
                        obj.data.map((value) => {
                            if (value.variant) {
                                data.push(value.variant);
                            } else {
                                data.push(value);
                            }
                        });
                        obj.data = data;
                        delete obj.name;
                    }
                });
            }
            let payload = {
                id: this.$route.params.id,
                data: {
                    externalAttributes: updatedAttributes,
                    variations: this.variations,
                },
            };

            let orderAttributePayload = [];

            this.orderAttributesItem.forEach((el) => {
                orderAttributePayload.push({
                    attributeRef: el._id,
                    isRequired: el.isRequired,
                    isInheritable: el.isInheritable,
                    applicableTo: el.applicableTo ? el.applicableTo : "ORDER",
                });
            });

            let orderAttributePayloadFinal = {
                id: this.$route.params.id,
                data: { orderAttributes: orderAttributePayload },
            };

            try {
                await this.$store.dispatch(
                    "catalog/setExternalAttribute",
                    payload,
                );

                if (this.inputObj.catalogType == "isProductType") {
                    try {
                        await this.$store.dispatch(
                            "catalog/updateOrderAtributeAction",
                            orderAttributePayloadFinal,
                        );
                        this.$toasted.success(
                            "Catalog details updated successfully!",
                        );
                    } catch (err) {
                        this.$toasted.error(
                            "Unable to update catalog details!",
                        );
                    }
                } else {
                    this.$toasted.success(
                        "Catalog details updated successfully!",
                    );
                }
            } catch (error) {
                this.$toasted.error(
                    error?.message || "Unable to update catalog details!",
                );
            }
        },
        onSwitchUpdate(data) {
            const dataobj = data;
            this.externalAttributesItem.map((obj) => {
                if (obj._id === dataobj._id) {
                    obj.isVariation = dataobj.isVariation;
                }
            });
            this.$forceUpdate();
            if (!dataobj.isVariation) {
                this.variations = this.variations.filter(
                    (obj) => obj.attrRef !== dataobj._id,
                );
            } else {
                this.variations.push({
                    data: [],
                    attrRef: dataobj._id,
                });
            }
            this.$forceUpdate();
        },
        changeThumbnail(e) {
            this.uploadImage("thumbnail", e);
        },
        async changeCatalogItem(item) {
            this.attributeItem = Array.from(this.tempAttribute);
            const selectedCatalog = this.catalogResultItem?.find(
                (e) => e._id == item,
            );
            const externalAttributes = selectedCatalog?.externalAttributes || [];

            if (!selectedCatalog) {
                this.InheritableAttribuItem = [];
                this.externalAttributesItem = [];
                this.validateAttributeList();
                return;
            }

            let isInheritable = externalAttributes.filter(
                (item) =>
                    item.isInheritable === true && item.isRequired === false,
            );

            this.InheritableAttribuItem = isInheritable;
            let isInheritableNotRemovable =
                externalAttributes.filter(
                    (item) => item.isInheritable === true,
                );
            let result = isInheritableNotRemovable.map((item) => {
                if (
                    item.attributeRef &&
                    typeof item.attributeRef === "object" &&
                    Object.entries(item.attributeRef).length > 0
                ) {
                    const { _id } = item.attributeRef;
                    item._id = _id;
                }
                item.isInheritableNotRemovable = true;
                return item;
            });
            this.externalAttributesItem = result;
            this.validateAttributeList();
        },
        async editCatalogItem(item) {
            if (this.$route.params.id) {
                await this.catalogTypeChange(this.inputObj.catalogType);
            }
            this.attributeItem = Array.from(this.tempAttribute);

            const selectedCatalog = this.catalogResultItem?.find(
                (e) => e._id == item,
            );
            const externalAttributes = selectedCatalog?.externalAttributes || [];

            if (!selectedCatalog) {
                this.InheritableAttribuItem = [];
                return;
            }

            let isInheritable = externalAttributes.filter(
                (item) =>
                    item.isInheritable === true && item.isRequired === false,
            );
            this.InheritableAttribuItem = isInheritable;
            let isInheritableNotRemovable = this.externalAttributesItem.filter(
                (item) => item.isInheritable === true,
            );
            let result = this.InheritableAttribuItem.filter((o1) =>
                this.externalAttributesItem.some(
                    (o2) => o1.attributeRef._id === o2.attributeRef._id,
                ),
            );
            if (result.length > 0) {
                result.map((Object) => {
                    let index = this.InheritableAttribuItem.indexOf(Object);
                    if (index !== -1)
                        this.InheritableAttribuItem.splice(index, 1);
                });
            }
        },
        addAttributeIntoTable() {
            if (this.attribute.isVariation) {
                this.variations.push({
                    data: [],
                    attrRef: this.attribute._id,
                });
            }
            try {
                if (this.attribute === "Please Selected Attribute") {
                    this.$toasted.info("Please Select Attribute!");
                } else {
                    let isTheir = this.externalAttributesItem.filter(
                        (item) => item._id === this.attribute._id,
                    );
                    if (isTheir.length === 0)
                        this.externalAttributesItem.push(this.attribute);
                }
            } catch (error) {
                console.error(error);
            }
        },

        addAttributeIntoTableOrder() {
            try {
                if (this.attribute === "Please Selected Attribute") {
                    this.$toasted.info("Please Select Attribute!");
                } else {
                    let isTheir = this.orderAttributesItem.filter(
                        (item) => item._id === this.attribute._id,
                    );
                    if (isTheir.length === 0)
                        this.orderAttributesItem.push(this.attribute);
                }
            } catch (error) {
                console.error(error);
            }
        },

        async createCatalog() {
            const valid = await this.$refs.observer.validate();
            if (!valid) return;
            // filter Label object with selected Lang.
            if (this.selectedLanguage.length > 0) {
                let keys = Object.keys(this.inputObj.catalogLabel);
                keys.map((key) => {
                    const ifKeyExist = this.selectedLanguage.some(
                        (obj) => obj.id === key,
                    );
                    if (!ifKeyExist) {
                        delete this.inputObj.catalogLabel[key];
                    }
                });
            }
            const { catalogType, ...payload } = this.inputObj;
            const mapAttribute = (item) => {
                const {
                    _id: attributeRef,
                    isComparable,
                    isSearchable,
                    isInheritable,
                    isRequired,
                    useInName,
                    defaultValue,
                    isVariation,
                    visibility,
                } = item;
                return {
                    attributeRef,
                    isComparable,
                    isSearchable,
                    isInheritable,
                    isRequired,
                    defaultValue,
                    useInName,
                    isVariation,
                    visibility,
                };
            };

            // console.log(mapAttribute);
            this.externalAttributesItem.map((obj) => {
                obj.visibility = {
                    onCreate: true,
                    onUpdate: true,
                    onShow: true,
                };
            });
            payload.externalAttributes =
                this.externalAttributesItem.map(mapAttribute);
            if (payload.parent && payload.parent.value) {
                payload.parent = payload.parent.value;
            }
            delete payload.catalogType;
            payload[catalogType] = true;
            payload.images = this.images;
            if (this.variations && this.variations.length > 0) {
                this.variations.map((obj) => {
                    if (obj) {
                        let data = [];
                        obj.data.map((value) => data.push(value.variant));
                        obj.data = data;
                        delete obj.name;
                    }
                });
            }

            let orderAttributePayload = [];

            this.orderAttributesItem.forEach((el) => {
                orderAttributePayload.push({
                    attributeRef: el._id,
                    isRequired: el.isRequired,
                    isInheritable: el.isInheritable,
                    applicableTo: el.applicableTo ? el.applicableTo : "ORDER",
                });
            });

            payload["variations"] = this.variations;

            if (this.inputObj.catalogType == "isProductType") {
                payload.orderAttributes = orderAttributePayload;
            }

            await this.$store
                .dispatch("catalog/createCatalogService", payload)
                .then((result) => {
                    this.$swal({
                        title: "Congratulation",
                        text: "Catalog has been saved Successfully",
                        type: "success",
                    });
                    this.$router.push({ path: "/catalog" });
                })
                .catch((error) => {
                    let errorText = "Something went wrong. ";
                    if (!this.inputObj.name) {
                        errorText += "Name is required. ";
                    }
                    if (!this.inputObj.catalogDescription.displayName) {
                        errorText += "Display name is required. ";
                    }
                    if (!this.inputObj.catalogDescription.longDescription) {
                        errorText += "Long description is required. ";
                    }
                    if (!this.inputObj.catalogDescription.shortDescription) {
                        errorText += "Short description is required. ";
                    }
                    if (this.externalAttributesItem.length === 0) {
                        errorText += "Add at least 1 external attribute. ";
                    }
                    // Check if all fields are empty
                    if (
                        !this.inputObj.name &&
                        !this.inputObj.catalogDescription.displayName &&
                        !this.inputObj.catalogDescription.longDescription &&
                        !this.inputObj.catalogDescription.shortDescription &&
                        this.externalAttributesItem.length === 0
                    ) {
                        errorText =
                            "All fields are required. Please fill in the necessary information.";
                    }
                    if (errorText) {
                        this.$swal({
                            title: "Oops",
                            text: errorText,
                            type: "error",
                        });
                    }
                });
        },
        getRowCount() {
            return this.externalAttributesItem.length;
        },
        async catalogTypeChange(item) {
            this.selectedCatalogType = item;
            // if (item === "isProductType") {
            //   this.catalogFields.push({
            //     key: "more",
            //     label: ""
            //   });
            // }
            let params = "";
            if (item === "isDomain") params = "isRoot";
            if (item === "isMarket") params = "isDomain";
            if (item === "isCategory") params = "isMarket";
            if (item === "isProductType") params = "isCategory";
            this.catalogListOption = [];
            this.catalogResultItem = [];
            if (!params) return;
            let res = await this.$store.dispatch(
                "catalog/fetchCatalogDataByParam",
                params,
            );
            if (res?.data?.response) {
                const uniqueCatalogs = [];
                const seenCatalogIds = new Set();
                const seenCatalogNames = new Set();

                res.data.response.forEach((item) => {
                    const catalogId = item?._id;
                    const displayName =
                        item?.catalogDescription?.displayName?.trim() || "";
                    const normalizedName = displayName.toLowerCase();

                    if (!catalogId || seenCatalogIds.has(catalogId)) {
                        return;
                    }

                    seenCatalogIds.add(catalogId);

                    if (displayName && seenCatalogNames.has(normalizedName)) {
                        return;
                    }

                    if (displayName) {
                        seenCatalogNames.add(normalizedName);
                    }

                    uniqueCatalogs.push(item);
                });

                this.catalogResultItem = uniqueCatalogs;
                this.catalogListOption = uniqueCatalogs.map((item) => ({
                    value: item._id,
                    text: item.catalogDescription.displayName,
                    type: this.getType(item),
                }));
            }
            // this.catalogListOption = this.catalogList.filter((e) => {
            // if (item === "isDomain") return e.type === "isRoot";
            // if (item === "isMarket") return e.type === "isDomain";
            // if (item === "isCategory") return e.type == "isMarket";
            // if (item === "isProductType") return e.type == "isCategory";
            // });
        },
        getAttributeItem() {
            try {
                const data = this.attributelist || [];
                const existingIds = new Set(
                    this.externalAttributesItem.map((i) => i._id),
                );

                this.tempAttribute = data
                    .filter((item) => {
                        if (this.edit && existingIds.has(item._id)) {
                            return false;
                        }
                        return true;
                    })
                    .map((item) => ({
                        ...item,
                        value: item._id,
                        text: item.attributeName,
                        isComparable: false,
                        isInheritable: false,
                        isRequired: false,
                        isSearchable: false,
                        isVariation: false,
                        useInName: false,
                        onCreate: true,
                        onUpdate: true,
                        onShow: true,
                        isInheritableNotRemovable: false,
                        defaultValue: "",
                    }));

                this.attributeItem = [...this.tempAttribute];
            } catch (error) {
                this.$toasted.error("Error loading attributes");
            }
        },
        deleteAttribute(data) {
            // check for variance
            if (data.item.isVariation) {
                this.variations = this.variations.filter(
                    (obj) => obj.attrRef !== data.item._id,
                );
            }
            // if it update..
            if (this.$route.params.id) {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert this action!!",
                    type: "warning",
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                }).then((result) => {
                    let { index } = data;
                    let { item } = data;
                    let { isParent } = item;
                    if (isParent) this.InheritableAttribuItem.push({ ...item });
                    this.externalAttributesItem =
                        this.externalAttributesItem.filter(
                            (obj) => obj._id !== data.item._id,
                        );
                });
            } else {
                let { index } = data;
                let { item } = data;
                let { isParent } = item;
                if (isParent) this.InheritableAttribuItem.push({ ...item });
                this.externalAttributesItem =
                    this.externalAttributesItem.filter(
                        (obj) => obj._id !== data.item._id,
                    );
            }
        },
        deleteAttributeOrder(data) {
            this.orderAttributesItem = this.orderAttributesItem.filter(
                (obj) => obj._id !== data.item._id,
            );
        },
        async addAtributeIntoExternalAttribute(data) {
            try {
                let { index } = data;
                let { item } = data;
                item._id = item.attributeRef._id;
                this.externalAttributesItem.push({ ...item, isParent: true });
                this.InheritableAttribuItem.splice(index, 1);
            } catch (error) {
                console.error(error);
            }
        },
        validateAttributeList() {
            // Collect all attribute IDs that should be excluded
            const excludedIds = new Set();
            
            // Add IDs from externalAttributesItem
            this.externalAttributesItem.forEach((item) => {
                if (item.attributeRef?._id) {
                    excludedIds.add(item.attributeRef._id);
                }
            });
            
            // Add IDs from InheritableAttribuItem
            this.InheritableAttribuItem.forEach((item) => {
                if (item.attributeRef?._id) {
                    excludedIds.add(item.attributeRef._id);
                }
            });
            
            // Filter out excluded items from attributeItem
            this.attributeItem = this.attributeItem.filter(
                (item) => !excludedIds.has(item._id)
            );
        },
        getType(catalog) {
            return catalog.isCategory
                ? "isCategory"
                : catalog.isDomain
                  ? "isDomain"
                  : catalog.isMarket
                    ? "isMarket"
                    : catalog.isProductType
                      ? "isProductType"
                      : catalog.isRoot
                        ? "isRoot"
                        : "";
        },
        toForm(catalog) {
            const result = { ...catalog };
            result.catalogType = this.getType(result);
            return result;
        },
        getCatalogTypeOptions() {
            if (
                JSON.parse(sessionStorage.getItem("userLogin"))["role"] ===
                "Tenant"
            ) {
                let tenantDomainType =
                    this.$store.getters["tenant/GetTenantCatalogAccess"];
                if (tenantDomainType === "DOMAIN") {
                    this.catalogTypes = this.catalogTypes.filter(
                        (obj) =>
                            obj.value !== "isRoot" && obj.value !== "isDomain",
                    );
                } else if (tenantDomainType === "MARKET") {
                    this.catalogTypes = this.catalogTypes.filter(
                        (obj) =>
                            obj.value !== "isRoot" &&
                            obj.value !== "isDomain" &&
                            obj.value !== "isMarket",
                    );
                }
            }
        },
    },
    mounted: async function () {
        Validator.extend(
            "parentSelected",
            (value) => {
                return this.inputObj.parent != "";
            },
            {
                hasTarget: true,
            },
        );
        this.loading = true;
        if (this.$route.params.id) {
            try {
                const result = await this.$store.dispatch(
                    "catalog/fetchCatalogById",
                    this.catalogId,
                );
                if (result.status === 1) {
                    this.getImageLibraryList(this.catalogId);
                    const catalogDoc =
                        this.$store.getters["catalog/GetCurrentReadCatalog"];

                    const { response } = catalogDoc;
                    this.inputObj = this.toForm(response);
                    if (!this.inputObj.catalogLabel) {
                        this.inputObj.catalogLabel = {
                            en: "",
                            bn: "",
                            te: "",
                        };
                    } else {
                        Object.keys(this.inputObj.catalogLabel).forEach(
                            (obj) => {
                                this.selectedLanguage.push({
                                    id: obj,
                                    name: this.langObj[obj],
                                });
                            },
                        );
                    }
                    if (response.variations && response.variations.length > 0) {
                        const seenAttrRefs = new Set();
                        response.variations.forEach((obj) => {
                            if (
                                obj?.attrRef?._id &&
                                !seenAttrRefs.has(obj.attrRef._id)
                            ) {
                                seenAttrRefs.add(obj.attrRef._id);
                                const values = (obj.data || []).map((data) => ({
                                    variant:
                                        typeof data === "string"
                                            ? data
                                            : data.variant || data,
                                }));
                                this.variations.push({
                                    data: values,
                                    attrRef: obj.attrRef._id,
                                });
                            }
                        });
                    }
                    this.fetchImages();
                    this.externalAttributesItem =
                        response.externalAttributes.map((item) => ({
                            ...item,
                            ...item.attributeRef,
                        }));

                    this.externalAttributesItem.forEach((obj) => {
                        if (!obj.defaultValue) {
                            this.$set(obj, "defaultValue", "");
                        }
                        if (!obj.visibility) {
                            this.$set(obj, "visibility", {
                                onCreate: true,
                                onUpdate: true,
                                onShow: true,
                            });
                            this.$set(obj, "onCreate", true);
                            this.$set(obj, "onUpdate", true);
                            this.$set(obj, "onShow", true);
                        } else {
                            this.$set(obj, "onCreate", obj.visibility.onCreate);
                            this.$set(obj, "onUpdate", obj.visibility.onUpdate);
                            this.$set(obj, "onShow", obj.visibility.onShow);
                        }
                    });

                    await this.editCatalogItem(this.inputObj.parent);
                    if (
                        this.$store.getters["attribute/GetAttributeList"]
                            .length === 0
                    ) {
                        try {
                            await this.$store.dispatch(
                                "attribute/getAttributesList",
                            );
                        } catch (error) {
                            this.$toasted.error(error.message);
                        }
                    }
                    this.getAttributeItem();

                    if (this.inputObj.catalogType == "isProductType") {
                        this.orderAttributesItem = response.orderAttributes.map(
                            (item) => ({
                                ...item,
                                ...item.attributeRef,
                            }),
                        );
                    }
                }
            } catch (error) {
                this.$toasted.error(
                    error?.message || "Error loading catalog details",
                );
            }
        } else {
            if (
                this.$store.getters["attribute/GetAttributeList"].length === 0
            ) {
                try {
                    await this.$store.dispatch("attribute/getAttributesList");
                } catch (error) {
                    this.$toasted.error(error.message);
                }
            }
            this.getAttributeItem();
            this.getCatalogTypeOptions();
        }
        await this.$store.dispatch("taxcode/fetchTaxcodeListforTenant");
        this.loading = false;
    },
    computed: {
        ...mapGetters({
            ImageLibraryList: "catalog/GetImageLibraryList",
            getCategoryList: "catalog/GetCategoryList",
        }),
        pageTitle() {
            return this.$route.params.id ? "Catalog Details" : "Create Catalog";
        },
        taxcodeList() {
            let data = this.$store.getters["taxcode/GetTaxcodeList"];
            let finalTax = [];
            try {
                if (Array.isArray(data) && data.length > 0) {
                    data.forEach((obj) => {
                        finalTax.push(obj.taxCode);
                    });
                }
                return finalTax;
            } catch (err) {
                return finalTax;
            }
        },
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        catalogTypes() {
            const data = [];
            if (this.userRole !== "Tenant") {
                data.push({ text: "Root", value: "isRoot" });
                data.push({ text: "Domain", value: "isDomain" });
            }
            (data.push({ text: "Market", value: "isMarket" }),
                data.push({ text: "Category", value: "isCategory" }),
                data.push({ text: "Product Type", value: "isProductType" }));
            return data;
        },
        attributelist() {
            return this.$store.getters["attribute/GetAttributeList"];
        },
        catalogId() {
            return this.$route.params.id;
        },
        totalRows() {
            return this.getRowCount();
        },
        captions() {
            return this.catalogFields;
        },
        variant() {
            return this.variantfield;
        },
        parentCatalogItemChange: {
            get: function () {
                return (
                    this.catalogListOption.find(
                        (option) => option.value === this.inputObj.parent,
                    ) || null
                );
            },
            set: function (newVal) {
                const parentId = newVal?.value || "";
                this.inputObj.parent = parentId;
                this.changeCatalogItem(parentId);
            },
        },
    },
};
</script>

<style scoped>
.catalog-details-page ::v-deep .card.border-info {
    border-color: var(--border-subtle) !important;
    border-radius: var(--radius-md) !important;
    box-shadow: var(--shadow-sm) !important;
    overflow: hidden;
}

.catalog-details-page ::v-deep .card.border-info > .card-header,
.catalog-details-page ::v-deep .card.border-info > .card-header.bg-primary {
    background:
        linear-gradient(
            180deg,
            rgba(var(--primary-rgb), 0.16) 0%,
            rgba(var(--primary-rgb), 0.08) 72%,
            rgba(var(--secondary-rgb), 0.06) 100%
        ) !important;
    border-bottom: 1px solid var(--border-subtle) !important;
    color: var(--text-strong) !important;
}

.catalog-details-page ::v-deep .card.border-info > .card-body {
    background:
        linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.98) 0%,
            rgba(var(--primary-rgb), 0.03) 100%
        );
}

.catalog-details-page ::v-deep .card.border-info > .card-header * {
    color: var(--text-strong) !important;
}

.catalog-details-page ::v-deep .form-control:disabled,
.catalog-details-page ::v-deep .form-control[readonly] {
    color: var(--text-strong) !important;
    background: var(--surface-soft) !important;
    border-color: var(--border-subtle) !important;
    box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03);
}

.catalog-details-page ::v-deep .vs__dropdown-toggle,
.catalog-details-page ::v-deep .v-input__slot {
    border-color: var(--border-subtle) !important;
    box-shadow: none !important;
}

.custom-library {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.custom-button {
    width: 100%;
    height: fit-content;
    position: relative;
    padding: 0;
    margin: 0;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.default-tax-class {
    width: 76px;
}
.back.button {
    position: absolute;
    top: 5px;
    right: 24px;
    background-color: var(--primary);
    color: #fff;
    border: 1px solid rgba(var(--primary-rgb), 0.2);
    transition: all 0.3s ease-in-out;
}
.back.button:hover {
    background-color: var(--tertiary);
    color: #fff;
    border: 1px solid rgba(var(--primary-rgb), 0.24);
}
.btn-equal-height {
    height: 38px;
    line-height: 38px;
    padding-top: 0;
    padding-bottom: 0;
}

.action-btn {
    min-width: 50px;
    height: 38px;
    line-height: 38px;
    padding: 0 16px;
    max-width: 120px;
}

.btn-orange {
    background: #fe7b08;
    border: #fe7b08;
}

.form-group-margin-left {
    margin-left: 60px;
}

.form-group-margin-left-large {
    margin-left: 140px;
}

.form-group-margin-left-medium {
    margin-left: 85px;
}

.form-group-margin-left-medium-small {
    margin-left: 50px;
}

.image-margin-left {
    margin-left: 60px;
}

.image-margin-left-small {
    margin-left: 35px;
}

.modal-actions-center {
    text-align: center;
    margin-left: 300px;
}

.gallery-input-title {
    margin-left: 55px;
    width: 180px;
}

.gallery-textarea {
    margin-left: 40px;
    width: 180px;
}

.btn-cancel-modal {
    width: 90px;
    margin-right: 12px;
    background-color: #ff4d6d;
    border-color: #ff4d6d;
    color: white;
    border-radius: 6px;
}

.btn-save-modal {
    width: 90px;
    background-color: #4a4aff;
    border-color: #4a4aff;
    color: white;
    border-radius: 6px;
}

@media (max-width: 991.98px) {
    .form-group-margin-left,
    .form-group-margin-left-large,
    .form-group-margin-left-medium,
    .form-group-margin-left-medium-small {
        margin-left: 0;
    }

    .image-margin-left,
    .image-margin-left-small {
        margin-left: 0;
    }

    .modal-actions-center {
        margin-left: 0;
    }

    .gallery-input-title,
    .gallery-textarea {
        margin-left: 0;
        width: 100%;
    }
}

@media (max-width: 767.98px) {
    .btn-cancel-modal,
    .btn-save-modal {
        width: 100%;
        margin-right: 0;
        margin-bottom: 0.5rem;
    }
}
@media (max-width: 576px) {
    .back.button {
        margin-left: 8px;
        padding-top: 4px;
        padding-bottom: 4px;
        height: 32px;
        min-height: unset;
        line-height: 1.2;
    }
    .form-group-margin-left {
        margin-left: 120px;
    }
    .image-group-margin {
        margin-left: 0px;
    }
}
@media (max-width: 576px) {
    .input-group {
        display: flex;
        align-items: baseline;
    }

    .input-group .form-control {
        flex: 0 0 65%;
        max-width: 65%;
        height: 34px;
    }

    .input-group .input-group-append {
        flex: 0 0 35%;
        max-width: 35%;
        display: flex;
    }

    .input-group .input-group-append .btn {
        width: 100%;
        height: 34px;
        padding: 0 12px;
    }
}
@media (max-width: 575.98px) {
    .mobile-center-icon {
        display: block;
        margin: 0 auto !important;
    }
}
@media (max-width: 576px) {
    .mobile-switch-align {
        display: grid;
        grid-template-columns: 40% 40%;
        row-gap: 10px;
        align-items: center;
        margin-left: 5px;
    }

    .mobile-switch-align > .col-2,
    .mobile-switch-align > .col-4 {
        all: unset;
        display: contents;
    }
    .btn-primary-save {
        width: 80%;
        align-content: center;
        margin-bottom: 5px;
        display: block;
        margin-left: 100px;
    }
}

@media (max-width: 576px) {
    .mobile-reset {
        margin-left: 0 !important;
    }

    .mobile-image-center {
        display: flex !important;
        flex-direction: column;
        align-items: center !important;
        margin-left: 12px;
        margin-right: 12px;
    }
}

@media (max-width: 576px) {
    .form-actions {
        display: flex;
        justify-content: center;
    }

    .text-right {
        text-align: center !important;
    }
}

.action-btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-wrap: nowrap;
}

.button-circle {
    width: 34px;
    height: 34px;
    min-width: 34px;
    min-height: 34px;
    border-radius: 50% !important;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    padding: 0 !important;
}

@media (max-width: 576px) {
    td {
        white-space: nowrap !important;
    }
}
.form-actions {
    text-align: center;
    padding-left: 460px;
    display: flex;
    justify-content: left; /* Centers horizontally */
    align-items: left;
}
.upd-btn {
    text-align: center;
    padding-right: 460px;
}
.save-btn {
    text-align: center;
    margin-right: 480px;
    height: 39px;
    min-width: 110px;
}
.catalog-update-btn {
    width: auto;
    min-height: 42px;
    padding: 0.625rem 1rem !important;
    border-radius: 12px !important;
    background: linear-gradient(
        180deg,
        var(--primary) 0%,
        var(--tertiary) 100%
    ) !important;
    border-color: transparent !important;
    color: #fff !important;
    box-shadow: 0 16px 32px -24px var(--primary-shadow-strong);
}

.catalog-update-btn:hover,
.catalog-update-btn:focus {
    background: linear-gradient(
        180deg,
        var(--tertiary) 0%,
        var(--primary) 100%
    ) !important;
}
</style>
<style>
.modal-header .close {
    color: black !important;
}
.modal-header .modal-title {
    color: black !important;
}

nav {
    display: flex;
    justify-content: flex-end;
}

nav .pagination {
    margin-top: 10px;
}
.form-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.action-btn {
    min-width: 160px;
    height: 42px;
    line-height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    border-radius: 6px;
}
</style>
